import * as React from "react";
import Flex from "antd/es/flex";
import Button from "antd/es/button";
import LeftOutlined from "@ant-design/icons/LeftOutlined";
import { FormModel } from "./types";
import { PaymentManager } from "./PaymentManager";
import { PayDescription } from "./PayDescription";
import { GatewayCreator } from "./GatewayCreator";

export interface PaymentGateProps {
    formModel: FormModel;
    setTransactionId: (txId: string) => void;
    setSuccess: () => void;
    onError: () => void;
    onBack: () => void;
}

export const PaymentGate: React.FunctionComponent<PaymentGateProps> = (props) => {

    return (
        <Flex gap="20px" vertical justify="center" align="center" className="PaymentGate">
            <GatewayCreator
                formModel={props.formModel}
                setTransactionId={props.setTransactionId}
            />
            {!props.formModel.transactionHash && (
                <Button
                    onClick={props.onBack}
                    htmlType="button"
                    icon={<LeftOutlined />}
                    iconPosition="start"
                    className="BackButton"
                >
                    Back
                </Button>
            )}
            <PayDescription formModel={props.formModel} />
            <PaymentManager onSuccess={props.setSuccess} formModel={props.formModel} />
        </Flex>
    );
};